import { render, staticRenderFns } from "./deanNotification.vue?vue&type=template&id=2c5478ae"
import script from "./deanNotification.vue?vue&type=script&lang=ts"
export * from "./deanNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports